// src/pages/Analytics.tsx
import React from "react";
import Sidebar from "../components/Sidebar";
import DashboardTopbar from "../components/DashboardTopbar";

const Analytics = () => {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 bg-[#f9f9f9]">
        <DashboardTopbar
          logoUrl="/logo.png"
          name="FullPlateNow Restaurant"
          address="123 Main St, Springfield"
        />
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-4">Analytics</h2>
          {/* …your analytics widgets go here… */}
        </div>
      </div>
    </div>
  );
};

export default Analytics;
